<template>
  <div>
    <div v-if="multiple_storage_retentions" class="alert alert-warning" role="alert">
      <div class="alert-icon">
        <i class="flaticon-warning" />
      </div>
      <div class="alert-text">
        You have multiple storage retentions, they will conflict with each other.
      </div>
    </div>
    <f-data-table id="customer_retention_table"
                  heading="Retentions"
                  icon="flaticon2-user-1"
                  :data-uri="data_uri"
                  :columns="columns"
                  :selectable-rows="false"
                  :server-side="true">
      <template #_actions="props">
        <div class="kt-portlet__head-toolbar">
          <div class="kt-portlet__head-wrapper">
            <button
              class="btn btn-ss-standout btn-icon-sm" @click="showCustomerRetentionModal()">
              <i class="flaticon2-plus" />New Retention
            </button>
            <button type="button"
                    class="btn btn-ss btn-icon-sm"
                    @click="props.reloadData">
              <i class="flaticon2-refresh" />Reload Data
            </button>
          </div>
        </div>
      </template>

      <template #actions="props">
        <div class="row-action-cell">
          <div class="dropdown dropdown-inline">
            <button type="button" class="btn btn-clean btn-icon"
                    data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
              <i class="flaticon-more-1" />
            </button>
            <div class="dropdown-menu dropdown-menu-right" style="">
              <ul class="kt-nav">
                <li v-perms="[`customer_retention`, `api.customer-retention.destroy`]" class="kt-nav__item">
                  <a href="javascript:;" class="kt-nav__link" @click="() => props.do({cb: deleteRetention(props.row.id)})">
                    <i class="kt-nav__link-icon flaticon2-trash" />
                    <span class="kt-nav__link-text">Delete</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </template>

      <template #check_against="props">
        <span v-if="props.value === 'publish_start'">Published Date</span>
        <span v-else>Created At</span>
      </template>

      <template #delete_related="props">
        {{ props.value ? 'Yes' : 'No' }}
      </template>
      <template #retention_days="props">
        {{ props.value }} {{ props.value > 1 ? 'Days' : 'Day' }}
      </template>
      <template #tags="props">
        <div>
          <span v-for="tag in props.value" :key="tag" class="kt-badge kt-badge--inline kt-badge--success mr-2">{{ tag }}</span>
        </div>
      </template>
      <template #created_at="props">
        {{ formatDate(props.row.created_at, `DD/MM/YYYY, hh:mm:ss`) }}
      </template>
    </f-data-table>

    <vjs-modal name="customer-retention-modal" title="Create retention configuration">
      <customer-retention-form :is-modal="true" @input="$modal.hide(`customer-retention-modal`)" />
    </vjs-modal>
  </div>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';

import FDataTable from "VuePartials/App/Storage/FDataTable/FDataTable.vue";
import CustomerRetentionForm from "VuePartials/App/CustomerRetention/CustomerRetentionForm";

export default {
  components: {
    CustomerRetentionForm,
    FDataTable,
    VjsModal,
  },
  data: () => ({
    multiple_storage_retentions: false,
  }),
  computed: {
    data_uri() {
      return `/api/v1/customer-retention`;
    },
    columns() {
      return [
        {
          display: "Type",
          field: "type",
          never_clip: true,
        },
        {
          display: "Check Against",
          field: "check_against",
        },
        {
          display: "Tags",
          field: "tags",
          sortable: false,
        },
        {
          display: "Retain For",
          field: "retention_days",
        },
        {
          display: "Delete Related",
          field: "delete_related",
        },
        {
          display: "Created At",
          field: 'created_at',
        },
        {
          field: `actions`,
          display: ``,
          sortable: false,
          width: 150,
          never_clip: true,
        },
      ];
    },
  },
  mounted() {
    window.EventBus.$on(`fdt-data-loaded`, (ev) => {
      this.multiple_storage_retentions = (ev.rows.filter(row => row.type === `storage`).length > 1);
    });
  },
  methods: {
    async deleteRetention(retention_id) {
      try {
        await axios.delete(`/api/v1/customer-retention/${retention_id}`);
        window.EventBus.$emit(`customer_retention_table-reload`);
        toastr.success(`Retention Deleted`);
      } catch (err) {
        window.handleAxiosError(err);
      }
    },
    showCustomerRetentionModal() {
      this.$modal.show(`customer-retention-modal`);
    },
  },
};
</script>
